import SvgIcon from '@mui/material/SvgIcon';
import { usePermissions } from '../../../../hooks/useCommon';
import { ReactComponent as RequiredIcon } from '../../../../static/icons/ic_required.svg';
import { STATUS_ICONS_MAP } from '../data/calendar';

const DayOffIndicator = ({ status }: { status: string }) => {
  const { permissions } = usePermissions();

  if (status === 'Pending' && !permissions.isEmployee) {
    return (
      <SvgIcon
        sx={{
          mr: 1,
          fontSize: 20,
        }}
        component={RequiredIcon}
        inheritViewBox
      />
    );
  }

  return (
    <SvgIcon
      className="cursor-pointer"
      component={STATUS_ICONS_MAP[status].icon}
      sx={{
        fontSize: 20,
        mr: 1,
      }}
      inheritViewBox
    />
  );
};

export {
  DayOffIndicator,
};
